import ApiService from '@/services/ApiService';

const SearchService = {
  list(page, limit, data) {
    let params = {...{page}, ...{limit}, ...data}
    return ApiService.post(`documents/search`, params)
  },

}
export default SearchService